import heroImage from '@/assets/hero-foliage.jpg';
import { Leaf, Sprout } from 'lucide-react';
import { Button } from '@/components/ui/button';
interface HeroSectionProps {
  onStartOfflineExperience: () => void;
}
export const HeroSection = ({
  onStartOfflineExperience
}: HeroSectionProps) => {
  return <section id="main-content" className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Preload hero image for LCP optimization */}
      <link rel="preload" as="image" href={heroImage} fetchPriority="high" />
      
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url(${heroImage})`
    }} role="img" aria-label="Lush green foliage creating a peaceful natural sanctuary for mindful retreat experiences">
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      
      {/* Botanical Accent - Top Left */}
      <div className="absolute top-8 left-8 z-10 opacity-20 animate-float">
        <Leaf className="w-16 h-16 md:w-24 md:h-24 text-white" strokeWidth={1} />
      </div>
      
      {/* Botanical Accent - Bottom Right */}
      <div className="absolute bottom-8 right-8 z-10 opacity-20 animate-float" style={{
      animationDelay: '1s'
    }}>
        <Sprout className="w-12 h-12 md:w-20 md:h-20 text-white" strokeWidth={1} />
      </div>
      
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-between h-full w-full px-6 py-12">
        
        {/* Main Content - Centered */}
        <div className="flex-1 flex items-center justify-center text-center max-w-4xl">
          <div>
            <h1 className="text-7xl md:text-9xl lg:text-[12rem] font-serif font-bold mb-16 leading-tight tracking-wide animate-fade-in">
              <div className="text-white font-bold">mystic</div>
              <div className="text-white font-bold">forest</div>
            </h1>
            
            <p className="text-3xl md:text-4xl lg:text-5xl text-white tracking-wide font-serif font-light animate-fade-in" style={{
            animationDelay: '0.2s'
          }}>
              <span className="relative inline-block">
                <span className="absolute inset-0 bg-[hsl(84,60%,45%)] opacity-80 transform -rotate-1 rounded-sm -z-10"></span>
                <span className="relative px-2 py-1 text-white">Offline</span>
              </span> is the new luxury
            </p>
          </div>
        </div>

        {/* Bottom CTA - Prominent */}
        <div style={{
        animationDelay: '0.6s'
      }} className="text-center animate-fade-in mb-12 my-[100px]">
          <Button onClick={onStartOfflineExperience} size="lg" className="rounded-full bg-transparent border-2 border-white text-white hover:bg-white/20 shadow-lg hover:shadow-xl transition-all duration-300 px-8 py-6 text-base font-medium tracking-wide">
            Enter the 60-Second Ritual*
          </Button>
          <p className="text-sm md:text-base text-white/90 mt-4 font-light tracking-wide italic">
            *Pause now. Scroll later (or maybe not at all).
          </p>
        </div>
      </div>

    </section>;
};